/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { ClaimMilestoneResponse, ClaimMilestoneVars } from '../openapi-types.gen.js';

export type { ClaimMilestoneResponse, ClaimMilestoneVars } from '../openapi-types.gen.js';

export const useClaimMilestone = createMutationHook<ClaimMilestoneVars, ClaimMilestoneResponse, unknown>({
  specName: 'useClaimMilestone',
  path: '/v1/rewards/milestones/{id}/claim',
  method: 'POST',
  resolveUrl: (vars: ClaimMilestoneVars) => `/v1/rewards/milestones/${vars.id}/claim`,
  
  parseResponse: (raw: unknown): ClaimMilestoneResponse => raw as ClaimMilestoneResponse,
  
  
  
});
